// src/components/AboutSection.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../styles/AboutSection.css";

export default function AboutSection() {
  return (
    <section id="about" className="about-section">
      <Container>
        <Row className="align-items-center">
          <Col lg={5} className="about-section__text">
            <h2 className="about-section__heading">Our Story</h2>
            <p className="about-section__blurb">
              Hear about the reason the Gail Thompson Foundation was started
              directly from Cal Thompson himself.
            </p>
            <p className="about-section__body">
              The foundation was created in honor of my grandmother, Gail Thompson.
              Walking with her through Alzheimer’s changed the way my family and I
              saw this disease, and it made me want to do something real for other
              families in Maine. In this video, I share what she meant to us, what
              we learned through her diagnosis, and why I started the Gail Thompson
              Foundation.
            </p>
          </Col>

          <Col lg={7}>
            <div className="about-section__video-wrapper">
              <div className="about-section__video-inner">
                <iframe
                  src="https://www.youtube.com/embed/YOUR_VIDEO_ID"
                  title="Why I Started the Gail Thompson Foundation"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
